import apiSportsEvents from '@/api/sports-events'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteSportsEventAthletesStart:
    '[delete sportsEvent Athletes] Delete sportsEvent Athletes start',
  deleteSportsEventAthletesSuccess:
    '[delete sportsEvent Athletes] Delete sportsEvent Athletes success',
  deleteSportsEventAthletesFailure:
    '[delete sportsEvent Athletes] Delete sportsEvent Athletes failure',
}

export const actionTypes = {
  deleteSportsEventAthletes:
    '[delete sportsEvent Athletes] Delete sportsEvent Athletes',
}

const mutations = {
  [mutationTypes.deleteSportsEventAthletesStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteSportsEventAthletesSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteSportsEventAthletesFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteSportsEventAthletes](context, {id}) {
    context.commit(mutationTypes.deleteSportsEventAthletesStart)
    return new Promise((resolve) => {
      apiSportsEvents
        .deleteSportsEventsAthletes(id)
        .then((response) => {
          context.commit(mutationTypes.deleteSportsEventAthletesSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteSportsEventAthletesFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
